var Iframe_default = {
  "iframe": "cB5iM"
};
export {
  Iframe_default as default
};
//# sourceMappingURL=Iframe-scss.js.map
